// Copyright (c) Move Closer 2022.

import { AuthConfig, TokenDriver } from '@movecloser/front-core'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const authConfig: AuthConfig = {
  refreshThreshold: 60,
  validThreshold: 5,
  tokenName: 'lirene_ecom_token',
  tokenDriver: TokenDriver.Single
}

export enum AuthSSOSource {
  Auth = 'auth',
  Cart = 'cart'
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const authSSOParamsKey = 'auth:sso-params'
export const authSSOSelectedProvider = 'auth:sso-provider'
export const authSSOCustomerData = 'auth:sso-customer'
export const authSSOSessionId = 'auth:sso-session-id'
export const authSSOSource = 'auth:sso-source'
